var chunkMapping = {
	"1087": [
		1087
	],
	"1444": [
		31444
	],
	"1791": [
		61791
	],
	"1999": [
		61999
	],
	"2815": [
		2815
	],
	"5052": [
		45052
	],
	"5482": [
		95482
	],
	"6325": [
		66325
	],
	"6473": [
		16473
	],
	"6940": [
		96940
	],
	"9839": [
		99839
	]
};
var idToExternalAndNameMapping = {
	"1087": [
		"default",
		"./AllBrands",
		26227
	],
	"2815": [
		"default",
		"./MyAccount",
		26227
	],
	"16473": [
		"default",
		"./ContentfulPage",
		26227
	],
	"31444": [
		"default",
		"./Checkout",
		26227
	],
	"45052": [
		"default",
		"./MyBag",
		26227
	],
	"61791": [
		"default",
		"./OrderConfirmation",
		26227
	],
	"61999": [
		"default",
		"./Resolver",
		49542
	],
	"66325": [
		"default",
		"./MastheadComponent",
		49542
	],
	"95482": [
		"default",
		"./Section",
		49542
	],
	"96940": [
		"default",
		"./Pdp",
		26227
	],
	"99839": [
		"default",
		"./ListingPageComponent",
		49542
	]
};
var idToRemoteMap = {
	"1087": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"2815": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"16473": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"31444": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"45052": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"61791": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"61999": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm",
			"externalModuleId": 49542
		}
	],
	"66325": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm",
			"externalModuleId": 49542
		}
	],
	"95482": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm",
			"externalModuleId": 49542
		}
	],
	"96940": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp",
			"externalModuleId": 26227
		}
	],
	"99839": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm",
			"externalModuleId": 49542
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}